import React from 'react';
import { Stack, Typography, TextField, InputAdornment, Box, MenuItem, Select, FormControl } from '@mui/material';
import { Search, SlowMotionVideo, Person } from '@mui/icons-material';
  import { useAuth } from '../../contexts/AuthContext';


const VideoFilters = ({ onSearchChange, onIntervenantChange, selectedIntervenant, intervenants, children }) => {

const { user } = useAuth();

  const isIntervenant = user?.role === 3;
  return (
    <Stack direction="column" spacing={4} sx={{ mb: 6, width: '100%' }}>
      {/* LIGNE 1 : TITRE & BOUTON PUBLIER */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          <Stack direction="row" spacing={1} alignItems="center">
            <SlowMotionVideo sx={{ color: '#4318FF', fontSize: 20 }} />
            <Typography sx={{ color: '#4318FF', fontWeight: 800, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px' }}>
              Streaming Management
            </Typography>
          </Stack>
          <Typography variant="h4" sx={{ fontWeight: 900, color: '#1B2559', mt: 0.5 }}>
    Video <span style={{ color: '#4318FF' }}>Manager</span>
  </Typography>
        </Box>
        
        {/* Ici s'affiche le bouton Publier passé en "children" */}
        {children}
      </Stack>

      {/* LIGNE 2 : RECHERCHE + FILTRE INTERVENANT */}
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center">
        {/* RECHERCHE */}
        <TextField
          placeholder="Rechercher une vidéo..."
          onChange={(e) => onSearchChange(e.target.value)}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: '#A3AED0' }} />
              </InputAdornment>
            ),
          }}
          sx={{ 
            bgcolor: '#fff', 
            borderRadius: '15px',
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            boxShadow: '0 10px 30px rgba(0,0,0,0.03)'
          }}
        />

        {/* SELECT INTERVENANT */}
        <FormControl sx={{ minWidth: { md: 280 }, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.03)' }}>
          {!isIntervenant && (
<Select
            value={selectedIntervenant}
            onChange={(e) => onIntervenantChange(e.target.value)}
            displayEmpty
            startAdornment={
              <InputAdornment position="start">
                <Person sx={{ color: '#A3AED0', ml: 1 }} />
              </InputAdornment>
            }
            sx={{ 
              borderRadius: '15px',
              '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
              fontWeight: 600, 
              color: '#1B2559'
            }}
          >
            <MenuItem value="">Tous les intervenants</MenuItem>
            {/* ✅ CORRECTION : Utilisation de id_user */}
            {intervenants.map((int) => (
              <MenuItem key={int.id_user} value={int.id_user}>
                {int.prenom_user} {int.nom_user}
              </MenuItem>
            ))}
          </Select>
          )}
        </FormControl>
      </Stack>
    </Stack>
  );
};

export default VideoFilters;
